import { BackButton, Breadcrumb } from 'components/app-header';
import Layout from 'components/layout';
import { LoadableContent } from 'components/loadable-content';

const WorkspaceCreate = () => (
  <>
    <BackButton />
    <Breadcrumb to='/' root>
      Workspaces
    </Breadcrumb>
    <Breadcrumb to='/'>New workspace</Breadcrumb>
    <LoadableContent loading>
      <Layout direction='row' />
    </LoadableContent>
  </>
);

export default WorkspaceCreate;
